import * as styles from './styles';
import getInitials from './utils/getInitials';
import { cn } from '@cobliteam/ui/utils';
import { Avatar as MuiAvatar } from '@material-ui/core';
import type { AvatarProps as MuiAvatarProps } from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';

import Icon from '@cobliteam/ui/icons';

import { colors, fonts, icons } from '../styles';

export interface AvatarProps extends MuiAvatarProps {
  name?: string;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Avatar = withStyles({
  root: {
    height: icons.size.larger,
    width: icons.size.larger,
    color: colors.gray.dark,
    lineHeight: icons.size.larger,
    fontSize: fonts.size.small,
    fontFamily: 'Roboto',
    fontWeight: fonts.weight.medium,
  },
  circle: {
    backgroundColor: colors.gray.light,
  },
  fallback: {
    backgroundColor: colors.gray.light,
    width: 21,
  },
})((props: AvatarProps) => {
  const { name, children, className, ...otherProps } = props;
  const initials = getInitials(name);

  return (
    <MuiAvatar className={cn(className, styles.iconWrapper)} {...otherProps} variant='circle'>
      {children || initials || <Icon name='images' />}
    </MuiAvatar>
  );
});

export default Avatar;
